import { IconLayer } from 'deck.gl';

export const tripIconLayer = (gpsData: any) => {
  if (gpsData.length === 0) return;

  const red = [255, 0, 0];
  const green = [0, 128, 0];
  const data = [];
  data.push({
    coordinates: [
      gpsData[gpsData.length - 1].lon,
      gpsData[gpsData.length - 1].lat,
    ],
    // Couleur rouge
    color: red,
  });
  data.push({
    coordinates: [gpsData[0].lon, gpsData[0].lat],
    // Couleur verte
    color: green,
  });
  return new IconLayer({
    id: 'trip-icon-layer-data',
    data,

    pickable: true,
    //orange fill
    getColor: (d) => d.color,
    getIcon: (d) => 'marker',
    sizeMaxPixels: 100,
    iconAtlas:
      'https://raw.githubusercontent.com/visgl/deck.gl-data/master/website/icon-atlas.png',
    iconMapping:
      'https://raw.githubusercontent.com/visgl/deck.gl-data/master/website/icon-atlas.json',
    getSize: 40,

    getPosition: (d: any) => d.coordinates,
  });
};
